"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6142],{

/***/ 12991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ sharedDefaultAdvancedProps; }
/* harmony export */ });
var sharedDefaultAdvancedProps = {
    strokeWidth: "0",
    opacity: "1",
    shadowBlur: "0",
    shadowOffsetX: "0",
    shadowOffsetY: "0",
    zIndex: 0
};



/***/ }),

/***/ 6142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ring_shape_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/shape/index.js + 17 modules
var shape = __webpack_require__(20655);
// EXTERNAL MODULE: ./node_modules/react-konva/es/ReactKonva.js + 3 modules
var ReactKonva = __webpack_require__(79566);
// EXTERNAL MODULE: ./components/templates/dynamic-template/segments-layout-list/canvas/helpers.js
var helpers = __webpack_require__(19174);
// EXTERNAL MODULE: ./segments/desktop/shape/shapes-service.js
var shapes_service = __webpack_require__(81471);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/ring.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var RingComponent = function(props) {
    var componentType = props.componentType, windowHeight = props.windowHeight, relativeTo = props.relativeTo, isPreview = props.isPreview;
    var shapeProps = (0,helpers/* getShapeProps */.ZG)(props, componentType);
    var relativeToElementY = (0,react.useMemo)(function() {
        return (0,shapes_service/* getRelativeToElementY */.q)({
            relativeTo: relativeTo,
            isPreview: isPreview
        });
    }, [
        windowHeight,
        relativeTo,
        isPreview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactKonva/* Ring */.FM, _object_spread_props(_object_spread({}, shapeProps, (0,shapes_service/* getFillProps */.B)(props)), {
        y: shapeProps.y + relativeToElementY
    }));
};
/* harmony default export */ var ring = (RingComponent);

// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/shape/layouts/default-props.js
var default_props = __webpack_require__(12991);
;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}



var shapeColor = color_consts.PROJECTS_BLUE_COLOR_NAME;
/* harmony default export */ var ring_shape_default_props = (default_props_object_spread({
    // Base
    innerRadius: "100",
    outerRadius: "35",
    x: "0",
    y: "0",
    scale: "1",
    cornerRadius: "0",
    rotation: "45",
    fill: shapeColor,
    align: align_types.ALIGN_TYPES.LEFT
}, default_props/* sharedDefaultAdvancedProps */.h));

;// CONCATENATED MODULE: ./segments/desktop/shape/layouts/ring-shape/ring-shape-component.js
function ring_shape_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ring_shape_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ring_shape_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ring_shape_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ring_shape_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ring_shape_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var RingShapeComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ring, ring_shape_component_object_spread_props(ring_shape_component_object_spread({}, props), {
        componentType: shape/* default.RingShapeComponent.type */.Z.RingShapeComponent.type
    }));
};
RingShapeComponent.defaultProps = ring_shape_default_props;
/* harmony default export */ var ring_shape_component = (RingShapeComponent);


/***/ }),

/***/ 81471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ getFillProps; },
/* harmony export */   "q": function() { return /* binding */ getRelativeToElementY; }
/* harmony export */ });
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12573);
/* harmony import */ var client_services_hooks_use_element_size__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72943);


var DEFAULT_GRADIENT_POINT_VALUE = 50;
var getPointParsedValue = function(pointValue) {
    if (pointValue === "0") return 0;
    return Number(pointValue) || DEFAULT_GRADIENT_POINT_VALUE;
};
var getFillProps = function(param) {
    var fill = param.fill, gradientFill = param.gradientFill;
    var fillProps = {
        fill: styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[fill]
    };
    if (gradientFill === null || gradientFill === void 0 ? void 0 : gradientFill.useLinearGradientFill) {
        fillProps = {
            fill: null,
            fillLinearGradientStartPoint: {
                x: 0,
                y: 0
            },
            fillLinearGradientEndPoint: {
                x: getPointParsedValue(gradientFill === null || gradientFill === void 0 ? void 0 : gradientFill.x),
                y: getPointParsedValue(gradientFill === null || gradientFill === void 0 ? void 0 : gradientFill.y)
            },
            fillLinearGradientColorStops: [
                0,
                styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[fill],
                1,
                styles_colors__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[gradientFill === null || gradientFill === void 0 ? void 0 : gradientFill.color] || "white"
            ]
        };
    }
    return fillProps;
};
var getRelativeToElementY = function(param) {
    var relativeTo = param.relativeTo, isPreview = param.isPreview;
    if (relativeTo) {
        console.log("isPreview: ", isPreview);
        var relativeElement = document.getElementById(relativeTo);
        if (relativeElement) {
            var elementY = (0,client_services_hooks_use_element_size__WEBPACK_IMPORTED_MODULE_1__/* .getElementScrollableHeight */ ._)(isPreview ? relativeElement.offsetParent || relativeElement : relativeElement);
            return elementY;
        }
    }
    return 0;
};


/***/ })

}]);